/** Registers the LinkButton parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseLinkButton } from './parser';
const linkButtonRegistration = {
    typeName: 'LinkButton',
    parser: parseLinkButton,
};
nodeRegistry.register(linkButtonRegistration);
//# sourceMappingURL=index.js.map